module.exports = __webpack_public_path__ + "media/hyper/images/bg-pattern-d5a5bdb81804f25c78b2a3631d43fbbb.png";